export const constant = {
  HttpURL: "https://testapi.needletech.ng/api/",
  ImgURL: "https://testapi.needletech.ng/",
  OfficeURL: "https://testapi.needletech.ng/office_structure",
  PostOfficeImg: "https://testapi.needletech.ng/api/office-structure",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export const role = {
  admin: 1,
  line_manager: 2,
  employee: 3,
  training_manager: 4,
};



// WEBPACK FOOTER //
// ./src/Constants/constant.js